import {App} from 'vue';
import DateUtil from '@/app/shared/helpers/date-util';

export interface IFilters {
    periodStringFromDates: (startDate: string, endDate: string) => string;
}

export default {
    install(app: App) {

        app.config.globalProperties.$filters = {
            periodStringFromDates: DateUtil.periodStringFromDates,
        };
    },
};
